<template>
  <div>
    <router-link
            :to="{
          path: '/',
          query: {
            pagenews,
            numnews,
            page,
            num,
            type: 'news'
          },
         }"
    >
      <a class="backLink">Back</a>
    </router-link>
    <div class="menu" id="menu">
      <div class="content1">
        <!-- <div class="logo">
          <router-link to="/">千种药用植物基因组数据库</router-link>
        </div> -->
        <div class="btn">
          <!-- <el-menu class="el-menu-demo" mode="horizontal">
            <el-menu-item index="1" class="black"><router-link to="/">Home</router-link></el-menu-item>
            <span></span>
            <el-menu-item index="3"><router-link to="/blastcenter">Blast</router-link></el-menu-item>
             <el-menu-item index="4">|</el-menu-item>
            <el-menu-item index="5"><router-link to="/primer">Primer design</router-link> </el-menu-item>
            <el-menu-item index="3"><router-link to="/download">Download</router-link></el-menu-item>
          </el-menu> -->
          <ul>
            <li class="black"><router-link to="/">Home</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/blastcenter">Blast</router-link></li>
            <li class="ww">|</li>
            <li><router-link to="/primer">Primer design</router-link></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="contenter">
      <div class="title">
        <span class="el-icon-document"></span>
        <span>News & Updates</span>
      </div>
      <h1 class="newsTitle" v-html="newsinfo.title">
        <!-- 千种药用植物基因组数据库上线啦 -->
      </h1>
      <div class="des" v-html="newsinfo.summary">
        经多年药用植物基因组测序事业的发展，由贝纳基因主导，多家单位共同参与的千种药用植物基因组数据库于2021年1月20日正式上线。
      </div>

      <div class="des1" v-html="newsinfo.content">
        <!-- <div class="textindent">
          千种药用植物基因组研究计划旨在3-5年内收集整理并测序完成1000种重要的药用植物基因组，并构建一个全球最大的药用植物基因组数据库。
        </div>
        <div class="textindent">
          该数据库汇集相关药用植物的基因组数据及其相关信息，提供基因组相关数据的搜索、比对和下载，及各种比较基因组分析的方法和服务。
        </div>
        <div class="textindent">
            该数据库旨在推动药用植物基因组学、次生代谢产物合成生物学及相关分子育种的研究，为科研探索及产业发展提供基础性支撑平台。
          </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Species from "../page/Species.vue";
export default {
  components: { Species },
  data() {
    return {
      newsinfo:{},
      pagenews:1,
      numnews:5,
      page:1,
      num:5,
    }
  },
  created(){
      this.pagenews = this.$route.query.pagenews
      this.numnews = this.$route.query.numnews
      this.page = this.$route.query.page
      this.num = this.$route.query.num
    window.addEventListener("scroll", this.handleScroll);
    let newsid = this.$route.query.newsid;
    if (newsid == "" || newsid == null) {
      this.$router.push("/");
    } else {
      this.getnewsbyid(newsid);
    }
  },
  methods:{
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let offsetTop = document.querySelector("#menu").offsetTop;
      let isFixed = scrollTop > offsetTop ? true : false;
      if (isFixed) {
        document.querySelector("#menu").style =
          "position: fixed;top:0;background:#fff;z-index:9999";
      } else {
        document.querySelector("#menu").style = "";
      }
    },
    getnewsbyid(id) {
      let that = this;
      let token = localStorage.getItem("authorization");
      //console.log(token);
      axios
        .get("/bena/server/news/getbyid?id="+id, {
          headers: { Authorization: token },
        })
        .then(function (response) {
          console.log(response);
          if (response.data.code == 0) {
            that.newsinfo = response.data.result;
          } else {
            that.$alert("Loading failed！" + response.data.msg, "Notice", {
              confirmButtonText: 'Confirm',
              callback: (action) => {},
            });
          }
        })
        .catch(function (error) {
          console.log(error.response);
          that.$alert("Loading failed！" + error.response.data.message, "Notice", {
            confirmButtonText: 'Confirm',
            callback: (action) => {},
          });
        });
    },
  }
};
</script>
<style scoped>
.menu {
  width: 100%;
  height: 60px;
  flex: 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 10px;
  box-shadow: 1px 1px 2px #ccc;
}
.menu .content1 {
  width: 1200px;
  height: 50px;
  margin: 0 auto;
  /* border: 1px solid red; */
}
.menu .black {
  color: #000;
}
.menu .content1 .logo {
  float: left;
  width: 250px;
  height: 50px;
  margin: 5px 0;
  /* border: 1px solid #ccc; */
  line-height: 50px;

  text-align: center;
}
.menu .content1 .logo a {
  text-decoration: none;
  font-size: 20px;
  color: seagreen;
  font-weight: bold;
}
.menu .content1 .btn {
  /* float: right; */
  width: auto;
}
.menu .content1 .btn ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.menu .content1 .btn ul li {
  float: left;
  padding: 0 20px;
  line-height: 50px;
}
.menu .content1 .btn ul li.ww {
  color: #ccc;
}
.menu .content1 .btn ul li a {
  text-decoration: none;
  color: #333;
  font-size: 14px;
}
.menu .content1 .btn ul li:nth-child(1) a {
  color: #000;
  font-weight: 700;
}
.menu .content1 .btn .el-menu.el-menu--horizontal {
  border: none;
}
.contenter {
  width: 1140px;
  margin: 0 auto;
  /* height: 500px; */
  box-shadow: 0 0 10px #bbb;
  padding: 0 30px;
  background: #fff;
  min-height: 500px;
}
.contenter .newsTitle {
  text-align: center;
  line-height: 30px;
  font-size: 16px;
}
.contenter .time {
  text-align: center;
  margin-left: 200px;
  font-size: 12px;
  color: #444;
}
.contenter .title {
  height: 70px;
  width: 100%;
  /* border: 1px solid red; */
  line-height: 70px;
  font-size: 16px;
  font-weight: bold;
}
.contenter .title .el-icon-document {
  margin-right: 10px;
  font-size: 20px;
  /* line-height: 30px; */
  color: seagreen;
  font-weight: bold;
}
.contenter .des {
  background: #eef6f0;
  color: #555;
  line-height: 25px;
  padding: 15px 20px;
  font-size: 14px;
  text-indent: 30px;
}
.contenter .des1 {
  /* background: #eef6f0; */
  color: #555;
  line-height: 30px;
  padding: 15px 20px;
  font-size: 14px;
}
.contenter .textindent {
  text-indent: 30px;
}
.contenter .img {
  width: 100%;
  text-align: center;
}
.contenter .img1 {
  width: 100%;
  text-align: center;
  overflow: auto;
}
.contenter .img1 div{
  width: 60%;
  margin: 0 auto;
}
.contenter .img1 img{
  float: left;
  width: 50%;
}
.contenter .img {
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  line-height: 25px;
  overflow: auto;
  padding-bottom: 30px;
}
.backLink{
  position: fixed;
  top: 15px;
  left:20px;
  background-color: white;
  text-underline: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 13px;
  color: #999;
}
</style>
